<template>
    <app-field :error="error" :classes="classes" :append="append">
        <app-label v-if="label != ''" :label="label" :required="required" :description="description"></app-label>

        <div class="flex w-full py-2" :class="options" v-bind="$attrs" slot="input">
            <div class="flex-grow text-center" v-for="item in data" v-bind:class="{'text-blue': content == item.value}">
                <app-icon @click="content = item.value; update()" :icon="item.icon" />
            </div>
        </div>
    </app-field>
</template>

<script>
    /* Components */
    import Field from '@/components/fields/Field';
    import Label from '@/components/fields/Label';
    export default {
        name: 'app-field-text',
        components: {
            'app-field': Field,
            'app-label': Label
        },
        props: {
            label: {
                type: String,
                default: ''
            },
            required: {
                type: Boolean,
                default: false
            },
            description: {
                type: String,
                default: ''
            },
            error: {
                type: String,
                default: ''
            },
            value: {
                default: ''
            },
            classes: {
                type: Object,
                default: () => ({})
            },
            append: {
                type: String,
                default: ''
            },
            data: {
                type: Array,
                required: true
            }
        },
        data: () => ({
            content: ''
        }),
        mounted() {
            if (this.value) {
                this.content = this.value;
            }
        },
        computed: {
            options() {
                let classes = {};
                if(typeof this.classes.input != 'undefined' && Object.keys(this.classes.input).length > 0) {
                    classes = {
                        ...this.classes.input
                    };
                }
                if(this.error != '') {
                    classes['error'] = true;
                }
                return classes;
            }
        },
        methods: {
            update() {
                this.$emit('input', this.content)
            }
        }
    }
</script>

<style lang="scss">
    @import '../../../sass/modules/inputs.scss';
</style>



// WEBPACK FOOTER //
// src/components/fields/inputs/FancyOption.vue